
import { defineComponent } from 'vue';

// Components
import WebAuthnView from 'client/containers/user/Views/WebAuthnView.vue';

// Services
import userResetPasswordService from 'client/services/userResetPasswordService';

export default defineComponent({
  name: 'WebAuthnUserResetPasswordHandler',

  components: {
    WebAuthnView,
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
    identityFirstMfa: {
      type: Boolean,
      default: false,
    },
    requestKey: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  methods: {
    async submitPasswordReset(): Promise<void> {
      this.isLoading = true;
      this.$emit('resetErrorMessage');

      try {
        const passwordResetInfo = {
          confirmationCode: this.requestKey,
          pwdResetToken: this.form.pwdResetToken,
          ...(this.identityFirstMfa ? {} : {
            confirm: this.form.confirm,
            password: this.form.password,
          }),
        };

        await userResetPasswordService.verifyWebAuthnSignature(
          passwordResetInfo,
          this.form.challenge.webauthn,
        );

        this.$emit('success');
      } catch (error) {
        this.$emit('error', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
